import Vue from 'vue';
import Vuex from 'vuex';
import question from '@/store/modules/question';
import event from '@/store/modules/event';
import stream from '@/store/modules/stream';
import user from '@/store/modules/user';
import appsettings from '@/store/modules/appsettings';
import pageSettings from '@/store/modules/pageSettings';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    question,
    event,
    stream,
    user,
    appsettings,
    pageSettings,
  },
});
